import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function SampleNextArrow(props) {
  const { onClick } = props;
  return (
    <button
      className="slide-arrow next-arrow fa-chevron-right"
      onClick={onClick}
    ></button>
  );
}

function SamplePrevArrow(props) {
  const { onClick } = props;
  return (
    <button
      className="slide-arrow prev-arrow fa-chevron-left"
      onClick={onClick}
    ></button>
  );
}
export default function PremiumSlider(props) {
  const settings = {
    autoplay: true,
    speed: 1000,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    centerMode: false,
    infinite: true,
    focusOnSelect: true,
    cssEase: "linear",
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };
  const image = props.image ? props.image : [];
  return (
    <div className="App">
      <Slider {...settings} className="full-blog-slider">
        {image
          ? image.map((item, key) => (
              <div className="slick-slideshow__slide" key={key}>
                <div className="blog-box text-center">
                  <div className="blog-img text-center">
                    <img src={item} style={{ height: "300px" }} alt="" />
                  </div>
                </div>
              </div>
            ))
          : ""}
      </Slider>
    </div>
  );
}
